// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xozlzcbqhyvzhvlozhhr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhvemx6Y2JxaHl2emh2bG96aGhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4MDgwMzYsImV4cCI6MjA3MTM4NDAzNn0.mjC90j17syHYjJSoYSDzgyqNWQQ5e-x15LCESpcd2nU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});